import { Component, ViewEncapsulation, Input, SimpleChanges, OnChanges } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LOADING_RULE, SanitizeHtmlPipe } from 'shared/util-common';

@Component({
  selector: 'app-prettified-rule',
  templateUrl: './prettified-rule.component.html',
  standalone: true,
  styleUrls: ['./prettified-rule.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MatProgressSpinnerModule, SanitizeHtmlPipe],
})
export class PrettifiedRuleComponent implements OnChanges {
  @Input() prettified: string;
  prettifiedString: string;
  loading = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.prettified.currentValue === LOADING_RULE) {
      this.loading = true;
      this.prettifiedString = '';
    } else if (changes.prettified.currentValue === '') {
      this.prettifiedString = '';
    } else {
      this.prettifiedString = this.getPrettified(changes.prettified.currentValue);
    }
  }

  getPrettified(prettified: string): string {
    if (!prettified) {
      return;
    }

    if (this.prettified === LOADING_RULE) {
      this.loading = true;
      return;
    } else {
      this.loading = false;
    }

    const tableStartIndex = prettified.indexOf('<table>');
    const rule = prettified.split('\n');

    if (tableStartIndex != -1 && this.prettified.includes('referenceRangePrettified')) {
      return `<div class="reference-range-rule">${prettified}</div>`;
    }

    if (rule.length == 1) {
      return `<div class="single-line-rule">${rule[0]}</div>`;
    }

    let ruleList = '';
    for (const r of rule) {
      ruleList = `${ruleList}<li>${r}</li>`;
    }
    return `<ul>${ruleList}</ul>`;
  }
}
